// extracted by mini-css-extract-plugin
export default {"container":"footer_container__p95L9","part_container":"footer_part_container__DTciv","part_title":"footer_part_title__4i+vC","text_container":"footer_text_container__ECz9q"};